"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireWildcard(require("react"));
var _multiSelectModule = _interopRequireDefault(require("./multi-select.module.scss"));
var _Checkbox = require("../../../elements/checkbox/Checkbox");
var _close = require("../../../assets/icons/close.svg");
var _classnames = _interopRequireDefault(require("classnames"));
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var _MultiSelect = require("./MultiSelect");
var ItemRenderer = function ItemRenderer(_ref) {
  var _classNames;
  var checked = _ref.checked,
    option = _ref.option,
    onClick = _ref.onClick;
  var _useContext = (0, _react.useContext)(_MultiSelect.ClearContext),
    options = _useContext.options,
    clearAll = _useContext.clearAll;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  if (option.value === _MultiSelect.CLEAR_OPTION_VALUE) {
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: clearAll,
      role: "button",
      tabIndex: 0,
      className: _multiSelectModule.default['multi-select__clear-option']
    }, /*#__PURE__*/_react.default.createElement(_close.ReactComponent, {
      className: _multiSelectModule.default['multi-select__clear-icon']
    }), t('multiSelect.clearAll'));
  }
  return /*#__PURE__*/_react.default.createElement(_Checkbox.Checkbox, {
    className: (0, _classnames.default)(_multiSelectModule.default['multi-select__checkbox'], (_classNames = {}, (0, _defineProperty2.default)(_classNames, _multiSelectModule.default['multi-select__checkbox--first'], option.value === options[0].value), (0, _defineProperty2.default)(_classNames, _multiSelectModule.default['multi-select__checkbox--last'], option.value === options[options.length - 1].value), _classNames)),
    checked: checked,
    label: option.label,
    value: option.value,
    name: option.value,
    id: option.value,
    onChange: onClick
  });
};
var _default = ItemRenderer;
exports.default = _default;